<div class="drag-scroll-container">
  <ng-content></ng-content>
</div>